export default __webpack_public_path__ + "static/media/btn-color-int_en@3x.9beea198.png";